import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { AlertController } from "ionic-angular";
import { Committee } from "../../models/interfaces/committee.model";
import { Hareline } from "../../models/interfaces/hareline.model";
import { Member } from "../../models/interfaces/member.model";
import { HarelineViewPage } from "../../pages/hareline/hareline_view";
import { MemberPage } from "../../pages/member/member";
import { MemberUpdatePage } from "../../pages/member/member_update";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-member_view",
  templateUrl: "member_view.html",
})
export class MemberViewPage {
  public static readonly MEMBER_UPD_ACCESS = "updateMember";
  public static readonly MEMBER_DEL_ACCESS = "deleteMember";
  public static readonly PLEDGE_VIEW_ACCESS = "viewPledge";
  public static readonly PAYMENT_VIEW_ACCESS = "viewPayment";
  public static readonly HARELINE_VIEW_ACCESS = "viewHareline";
  public static readonly RATING_UPD_ACCESS = "updateRating";
  public static readonly ATTENDANCE_DEL_ACCESS = "deleteAttendance";

  private currentUser: Member;
  private mbrCommittees;
  private hasServed: boolean = false;
  private hasViewPaymentAccess: boolean = false;
  private hasViewPledgeAccess: boolean = false;
  private hasUpdMemberAccess: boolean = false;
  private hasAddAttendanceAccess: boolean = false;
  private hasDelMemberAccess: boolean = false;
  private hasDelAttendanceAccess: boolean = false;
  private hasUpdRatingAccess: boolean = false;
  private hasViewRunAccess: boolean = true;
  private isVisibleForChapter: boolean = true;
  private isPledgeVisible: boolean = false;
  private isPaymentVisible: boolean = false;
  private isRunVisible: boolean = false;
  private mb_id: number;
  private mb_hashname: string;
  private pledge: any;
  private payment = [];
  private paymenttype = [];
  private showAttended: boolean = true;
  private showCommittee: boolean = true;
  private showContact: boolean = true;
  private showPayment: boolean = true;
  private showPledges: boolean = true;
  private showRuns: boolean = true;
  private ttl_runcount: number;
  private mbrruncount: any;
  private mbrruns$: any;
  private mbrruns: Hareline;
  private displayPic: boolean = false; // Suppress photos for components
  private page: string = "pledge";
  private member;
  private styleName: string ="";

  constructor(private configService: ConfigService,private authService: AuthService, public navCtrl: NavController,
    public navParams: NavParams, public alertCtrl: AlertController,
    private db: DbserviceProvider,
  ) {
    console.log("MemberViewPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.mb_id = this.navParams.get("member").mb_id;
    this.mb_hashname = this.navParams.get("member").mb_hashname;
  }

  private ionViewWillEnter() {
    console.log("MemberViewPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("MemberViewPage onInitPage");
    this.member = this.navParams.get("member");

    if (this.authService.currentUser) {
      this.authService.currentUser.subscribe(
        (user) => {
          this.currentUser = user;
          this.hasUpdMemberAccess = this.db.hasAccess(MemberViewPage.MEMBER_UPD_ACCESS);
          this.hasDelMemberAccess = this.db.hasAccess(MemberViewPage.MEMBER_DEL_ACCESS);
          this.hasViewPledgeAccess = this.db.hasAccess(MemberViewPage.PLEDGE_VIEW_ACCESS);
          this.hasViewPaymentAccess = this.db.hasAccess(MemberViewPage.PAYMENT_VIEW_ACCESS);
          this.hasViewRunAccess = this.db.hasAccess(MemberViewPage.HARELINE_VIEW_ACCESS);
          this.hasUpdRatingAccess = this.db.hasAccess(HarelineViewPage.RATING_UPD_ACCESS);
          this.hasDelAttendanceAccess = this.db.hasAccess(MemberViewPage.ATTENDANCE_DEL_ACCESS);
          this.isRunVisible = (user.mb_hashname == this.mb_hashname ? true : false);
          this.isPledgeVisible = (user.mb_hashname == this.mb_hashname ? true : false);
          this.isPaymentVisible = (user.mb_hashname == this.mb_hashname ? true : false);

          if ( this.styleName=="dash" ){
            this.isVisibleForChapter=false;
          }
        },
      );

      this.db.dbCol({
        "action": "select", "mapObject": "vw_payment",
        "sqlExtended": " where mb_id='" + this.mb_id + "'",
      }).subscribe((data) => {
        this.member = data[0];
        data.forEach((element) => {
          if (this.payment[element.mb_hashname] === undefined) {
            this.payment[element.mb_hashname] = [];
          }
          this.payment[element.mb_hashname][element.pm_type + "id"] = element.py_id;
          this.payment[element.mb_hashname][element.pm_type] = element.py_amount;
          this.payment[element.mb_hashname].mb_photo = element.mb_photo;
          this.payment[element.mb_hashname].mb_birthdate = element.mb_birthdate;
          this.payment[element.mb_hashname].mb_resignationdate = element.mb_resignationdate;
          this.payment[element.mb_hashname].mb_status = element.st_name;
          this.payment[element.mb_hashname].py_id = element.py_id;
          this.payment[element.mb_hashname].mb_id = element.mb_id;
          this.payment[element.mb_hashname].co_id = element.co_id;
          this.payment[element.mb_hashname].se_id = element.se_id;
          this.payment[element.mb_hashname]["py_date" + element.pm_type] = element.py_date;
          this.payment[element.mb_hashname].pm_id = element.pm_id;
          this.payment[element.mb_hashname].py_amount = element.py_amount;
          this.payment[element.mb_hashname]["py_remark_" + element.pm_type] = element.py_remark;
          this.payment[element.mb_hashname].mb_hashname = element.mb_hashname;
          this.payment[element.mb_hashname].mb_notes = element.mb_notes;
        });
      });

      this.db.dbCol({
        "action": "select", "mapObject": "payment_type",
        "sqlExtended": " order by pm_order"
      }).subscribe((data) => {
        this.paymenttype = data;
      });

      this.mbrruns$ = this.db.dbCol({
        "action": "select",
        "mapObject": "vw_hareline",
        "sqlExtended": " where mb_id='" + this.mb_id + "' and hs_type='H' order by hl_datetime desc"
      });

      this.db.dbCol({
        "action": "select",
        "mapObject": "vw_attendance_cfmd",
        "sqlExtended": " where mb_id='" + this.mb_id + "' order by hl_datetime desc"
      }).subscribe((runc) => {
        this.mbrruncount = runc;
        this.ttl_runcount = 0
        runc.forEach((element) => {
          this.ttl_runcount = Number(this.ttl_runcount) + Number(element.rc_runcount);

        })
      })

      this.db.dbCol({
        "action": "select", "mapObject": "pledge",
        "sqlExtended": " where pledge.mb_id='" + this.mb_id + "' order by pledge.pl_date desc",
      }).subscribe((pl)=>{
        this.pledge=pl;
      });

      this.db.dbCol({
        "action": "select", "mapObject": "committee_member_role",
        "sqlExtended": " where role.ro_group='Committee'and member.mb_id='" + this.mb_id + "'  order by committee.co_todate desc, role.ro_order asc",
      }).subscribe((cmt) => {
        if (cmt.length>0){
        this.hasServed = !this.hasServed
        }
        this.mbrCommittees = cmt;
      })
    }
  }

  private launchWhasApp() {
    console.log("MemberViewPage launchWhasApp");
    window.open("whatsapp://send?phone=" + this.member.mb_contact_mobile + "&text=Hi " + this.member.mb_hashname, "_system", "location=yes");
  }

  private resetPassword() {
    console.log("MemberViewPage resetPassword");

    let confirm = this.alertCtrl.create({
      "buttons": [
        {
          "handler": () => {
            this.db.dbCol({
              "action": "dml", "mapObject": "dml",
              "query": "update member set mb_password_hash='$2y$10$6l.8Tpow1QgDU9Cq79sKYeVmX4TcbAm8EbyirCRoI4IuVfOX6Zso6',  mb_activation_hash=null, mb_password_reset_hash=mb_id where mb_id = " + this.mb_id,
            })
              .subscribe((ret) => {
                this.navCtrl.pop();
              });
          },
          "text": "Yes",
        },
        {
          "handler": () => {

          },
          "text": "No",
        },
      ],
      "message": "Do you want to reset the password for " + this.mb_hashname + " to pass4321@ ?",
      "title": "Reset Password",
    });
    confirm.present();
  }

  private resetRunCount() {
    let alert = this.alertCtrl.create({
      title: 'Add Run Count for ' + this.mb_hashname,
      inputs: [
        {
          name: 'username',
          placeholder: 'Number of Runs to add'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Add',
          handler: data => {

            this.db.dbCol({
              "action": "dml", "mapObject": "dml",
              "query": " call Add_RunCount(" + this.mb_id + "," + data.username + ")",
            })
              .subscribe((ret) => {
                this.navCtrl.pop();
              });
            /*
            if (User.isValid(data.username, data.password)) {
              // logged in!
            } else {
              // invalid login
              return false;
            }*/
          }
        }
      ]
    });
    alert.present();
  }

  private launchEmail() {
    console.log("MemberViewPage launchEmail");
    window.open("mailto:" + this.member.mb_email_id, "_system");
  }

  private launchPhoneCall() {
    console.log("MemberViewPage launchPhoneCall");
    let call = "tel:" + this.member.mb_contact_mobile;
    document.location.href = call;
  }

  private ngOnDestroy() {
    console.log("MemberViewPage ngOnDestroy");
  }

  private deleteMember(id: any) {
    console.log("MemberViewPage deleteMember");
    this.showConfirm("Member", "Do you want to delete the Member?", id);
  }

  private viewHareline(hareline: Hareline) {
    console.log("HarelinePage viewHareline");
    //push hareline in the first 0 element of the array otherwise target page will crash
    // since it expects a value in [0]
    const arr = [];
    arr.push(hareline);
    
    if ( Number(hareline.hl_runno) !== 0 ){
    this.navCtrl.push(HarelineViewPage, {
      "hareline": arr,
    });
  }
  }

  private updateMember() {
    console.log("MemberViewPage updateMember");
    this.navCtrl.push(MemberUpdatePage, {
      "member": this.member,
    });
  }

  private togglePledge() {
    console.log("HarelinePage togglePledge");
    this.showPledges = !this.showPledges;
  }

  private toggleContact() {
    console.log("HarelinePage toggleContact");
    this.showContact = !this.showContact;
  }

  private togglePayment() {
    console.log("HarelinePage togglePayment");
    this.showPayment = !this.showPayment;
  }
  private toggleRuns() {
    console.log("HarelinePage toggleRuns");
    this.showRuns = !this.showRuns;
  }

  private toggleCommittees() {
    console.log("HarelinePage toggleCommittee");
    this.showCommittee = !this.showCommittee;
  }
  private toggleAttended() {
    console.log("HarelinePage toggleAttended");
    this.showAttended = !this.showAttended;
  }

  private showConfirm(title: string, message: string, id: string) {
    let confirm = this.alertCtrl.create({
      "buttons": [
        {
          "handler": () => {
            this.db.dbCol({
              "action": "delete", "mapObject": "member", "mb_id": this.mb_id,
            }).subscribe((ret) => {
              this.navCtrl.pop();
            });
          },
          "text": "Yes",
        },
        {
          "handler": () => { },
          "text": "No",
        },
      ],
      "message": message,
      "title": title,
    });
    confirm.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/member/member_view.ts